firebird.factory('videoBitrateService', [
    '$timeout',
    '$window',
    'logService',
    'attendeeService',
    'connectivityService',
    'socketService',
    'storageService',
    'configService',
    'analyticsWrapperService',
    'videoGlobalService',
    function (
        $timeout,
        $window,
        logService,
        attendeeService,
        connectivityService,
        socketService,
        storageService,
        configService,
        analyticsWrapperService,
        videoGlobalService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoBitrateService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            //Used to set/restore default bitrate
            self.defaultBitrate = {
                video: 1000000,
                simulcast: 1500000,
                max: 1500000,
                min: 300000,
                altmin: 300000,
                lowest: 100000
            };

            self.lowPerformanceBitrate = {
                video: 500000,
                simulcast: 600000,
                max: 600000,
                min: 100000,
                altmin: 100000,
                lowest: 30000
            };

            self.lowerPerformanceBitrate = {
                video: 320000,
                simulcast: 400000,
                max: 400000,
                min: 70000,
                altmin: 70000,
                lowest: 30000
            };

            // undefined indicating not set, or true or false indicating low bitrate mode or not.
            // value of "lower" indicates level 2 (see videoLowPerformanceService), with lower bitrate.
            // for backward compatibility (without videoLowConfig flag), preserve true and false values.
            // the value is same as what can be returned by getIsVideoLow().
            self.videoLowBitrate = undefined;

            // several bitrate values are stored in this object.
            // configured value adjusted from URL param or user pair or settings.
            // actual = current value, may be adjusted on slow link events, only when adjust is true.
            // if adjust is object and altmax is 0 then auto-adjust is in play with
            // min and max. For two-party call, alt-adjust is done, with altmax valid
            // and adjust storing the adjusted value.
            self.bitrate = {
                screen: 1000000,
                file: 1500000, // configured from url param or settings
                substream: { low: 100000, medium: 400000, high: 1000000 }, // configured from settings
                altmax: 0,
                available: 0, // config for auto-adjust algorithm
                subscriber: { substream0: 170, substream1: 350, currentLimit: 900, previousLimit: 1000 },
                detect: { increase: 1.1, decrease: 100 }, // adjust if detected available bitrate change by this or more: 10% increase, 100kb/s decrease.
                change: { increase: 100000, incfactor: 1.0, decrease: 100000, decfactor: 1.0 }, // auto-adjust change bitrate in kb/s
                adjust: null // if auto-adjust then of the form {video: 0, screen: 0}
            };

            Object.assign(self.bitrate, self.defaultBitrate);

            // audio bitrate changed from Url param; default 0 indicates automatic.
            self.audioBitrate = 0;

            // if auto-adjust bitrate is set, then whether to auto-adjust framerate or not. null or 'fixed', 'auto'
            // this is different from frameRate parameter, which controls the (max) framerate number.
            // use the videoFramerate URL param or user pair to control this.
            self.videoFramerate = null;

            // whether to act on subscriber side slow link. If not null, can be comma separate values.
            // null (default): adjust simulcast substream, and if not using simulcast then inform publisher.
            // 'noinform': do not inform publisher about slowlink event, irrespective of simulcast.
            // 'alwaysinform': inform publisher always about slowlink event, irrespective of simulcast.
            // 'nosimulcast': do not adjust simulcast substream.
            // The default can be changed using the adjustSubscriber URL param.
            self.adjustSubscriber = null;

            // whether to use available bandwidth estimation to adjust the two-party publish rate or simulcast substream selection.
            // can be altered using URL param to disable if needed for testing.
            self.adjustOnAvailableBandwidth = true;

            // whether to adjust publisher bitrate on subscriber slowlink event, if no simulcast enabled.
            // Can be altered with sendSlowLink URL param.
            self.sendSlowLink = true;

            // How long the subscriber quality (simulcast substream) change remains after onSlowLink event?
            self.adjustQualityTimeoutSubscriber = 15000;

            // How often the publisher quality adjusted if videoBitrateRange is valid.
            self.adjustQualityTimeoutPublisher = 10000;

            // timer objects for adjusting bitrate, indexed by "{id}-{screen|video}"
            self.bitrateTimer = {};

            // these should not be allowed to be configured from params.
            self.reducePublisherAdjustData = {
                // current count of adjust skip
                skipCount: 0,
                // timer to accumulate slow link on skip
                screenTimer: null,
                videoTimer: null,
                // delayed/stored bandwidth
                screenBandwidth: 0,
                videoBandwidth: 0
            };

            self.reducePublisherAdjust = {
                // whether to enable reduce publisher adjust. Default is true.
                enabled: true,
                bitrate: {
                    // for faster increase in bitrate if higher available bitrate
                    // 0 removes the consideration, similar to previous code.
                    incfactor: 0.5,
                    // wait 5 sec before adjust bitrate after first time
                    delay: 5000,
                    // high limit for available bitrate
                    high: 1200000,
                    // limit for small increase in available bitrate
                    delta: 100000,
                    // if available bitrate is too high, and difference between current
                    // and available is not much, then skip adjust bitrate, every skip iteration.
                    skip: 2
                }
            };

            self.reduceSubstreamChangeDefault = {
                // whether to enable reduce substream change. Default is true.
                enabled: true,
                // if true then reset to 0 instead of reduce count.
                resetSlowLink: false,
                // factor of how much higher should available bitrate be compared to threshold.
                factorThreshold: 1
            };

            self.reduceSubstreamChange = Object.assign({}, self.reduceSubstreamChangeDefault);

            self.slowLinkGlobalTimer = null;
            self.slowLinkGlobalCount = 0;
            self.slowLinkUsers = new Set();

            self.onSlowLink = onSlowLink;

            self.adjustPublisherSlowLinkBandwidth = adjustPublisherSlowLinkBandwidth;
            self.shouldSkipAdjustPublishBandwidth = shouldSkipAdjustPublishBandwidth;
            self.tryAdjustScreenPublishBandwidth = tryAdjustScreenPublishBandwidth;
            self.tryAdjustVideoPublishBandwidth = tryAdjustVideoPublishBandwidth;
            self.getAdjustVideoPublishBandwidth = getAdjustVideoPublishBandwidth;
            self.calculateAdjustScreenPublishBandwidth = calculateAdjustScreenPublishBandwidth;
            self.calculateAdjustVideoPublishBandwidth = calculateAdjustVideoPublishBandwidth;
            self.adjustScreenPublishBandwidth = adjustScreenPublishBandwidth;
            self.adjustVideoPublishBandwidth = adjustVideoPublishBandwidth;
            self.cancelAdjustVideoPublishBandwidth = cancelAdjustVideoPublishBandwidth;
            self.cancelAdjustScreenPublishBandwidth = cancelAdjustScreenPublishBandwidth;

            self.adjustSubscriberSimulcast = adjustSubscriberSimulcast;
            self.adjustSubscriberSimulcastOnLost = adjustSubscriberSimulcastOnLost;
            self.shouldAdjustSubscriberSimulcastOnBitrate = shouldAdjustSubscriberSimulcastOnBitrate;
            self.adjustSubscriberSimulcastRevertAfter = adjustSubscriberSimulcastRevertAfter;
            self.adjustSubscriberSimulcastGlobalRevertAfter = adjustSubscriberSimulcastGlobalRevertAfter;
            self.recoverSimulcastForSlowLinkVideos = recoverSimulcastForSlowLinkVideos;
            self.checkAndResetGlobalSlowLinkCount = checkAndResetGlobalSlowLinkCount;

            self.adjustSubscriberSlowLinkBandwidth = adjustSubscriberSlowLinkBandwidth;
            self.adjustPublisherFrameRateForBitrate = adjustPublisherFrameRateForBitrate;
            self.createVideoBitrateControl = createVideoBitrateControl;
            self.destroyVideoBitrateControl = destroyVideoBitrateControl;
            self.getVideoBitrate = getVideoBitrate;
            self.createAltVideoBitrateControl = createAltVideoBitrateControl;
            self.destroyAltVideoBitrateControl = destroyAltVideoBitrateControl;
            self.updateAvailableVideoBitrate = updateAvailableVideoBitrate;

            self.initBitrate = initBitrate;
            self.initAudioBitrate = initAudioBitrate;
            self.setInitialBitrate = setInitialBitrate;

            self.getTargetPerformanceBitrate = getTargetPerformanceBitrate;
            self.enableLowPerformanceBitrate = enableLowPerformanceBitrate;
            self.disableLowPerformanceBitrate = disableLowPerformanceBitrate;

            self.reapplyPublishBitrate = reapplyPublishBitrate;
        }

        function initBitrate() {
            // change config of adjust bitrate
            var adjustBitrate = configService.getValue('adjustBitrate');
            if (adjustBitrate) {
                var parts = adjustBitrate.split(',').map(function (item) {
                    return parseFloat(item);
                });
                var invalids = parts.filter(function (item) {
                    return isNaN(item);
                });
                if (parts.length == 4 || invalids.length > 0) {
                    self.bitrate.change.increase = Math.round(parts[0]) * 1000;
                    self.bitrate.change.incfactor = parts[1];
                    self.bitrate.change.decrease = Math.round(parts[2]) * 1000;
                    self.bitrate.change.decfactor = parts[3];
                } else {
                    logger.warn('initBitrate', 'invalid four adjustBitrate values', adjustBitrate);
                }
            }

            // change config to adjust lowPerformanceBitrate and lowerPerformanceBitrate defaults.
            // this should be done before any calls to reapplyPublishBitrate after the change.
            var videoLowBitrate = configService.getValue('videoLowBitrate');
            if (videoLowBitrate) {
                var container = { low: self.lowPerformanceBitrate, lower: self.lowerPerformanceBitrate };
                self.setConfigObjectFromCSV(container, videoLowBitrate);
            }

            // this is needed *before* checking self.bitrate.adjust in the next step.
            self.setInitialBitrate();

            // whether to adjust based on subscriber side slow link events.
            self.adjustSubscriber = configService.getClientValue('adjustSubscriber');

            // whether to adjust based on available bandwidth estimation. Default is true.
            self.adjustOnAvailableBandwidth = configService.getClientValue('adjustOnAvailableBandwidth') != 'false';

            self.setConfigObjectFromValue(
                'reduceSubstreamChange',
                configService.getValue('reduceSubstreamChange'),
                self.reduceSubstreamChange,
                self.reduceSubstreamChangeDefault
            );

            self.setConfigObjectFromValue(
                'reducePublisherAdjust',
                configService.getValue('reducePublisherAdjust'),
                self.reducePublisherAdjust
            );
        }

        // audioBitrate from URL param
        function initAudioBitrate() {
            self.audioBitrate = 0;
            var audioBitrate = configService.getClientValue('audioBitrate');
            if (audioBitrate) {
                self.audioBitrate = parseInt('' + audioBitrate) || 0;
            }
        }

        function setInitialBitrate() {
            self.reapplyPublishBitrate();

            var fromQuery = false;

            // only applicable when videoBitrate is also present.
            self.videoFramerate = configService.getValue('videoFramerate');

            var bitrateParam = configService.getValue('videoBitrate'); // default is auto-adjust
            if (bitrateParam && bitrateParam != 'fixed') {
                // but do not set from query, if fixed supplied; same as null
                if (setInitialBitrateFromQueryParam(bitrateParam)) {
                    //bitrate set, but continue to use other query param is supplied.
                    fromQuery = true;
                }
            }

            var bitrateParamScreen = configService.getClientValue('videoBitrateScreen');
            if (bitrateParamScreen) {
                var bitrateParamScreenInt = parseInt(bitrateParamScreen);
                if (!isNaN(bitrateParamScreenInt)) {
                    self.bitrate.screen = bitrateParamScreenInt;
                }
            }

            var bitrateParamFile = configService.getClientValue('videoBitrateFile');
            if (bitrateParamFile) {
                var bitrateParamFileInt = parseInt(bitrateParamFile);
                if (!isNaN(bitrateParamFileInt)) {
                    self.bitrate.file = bitrateParamFileInt;
                }
            }

            var updateDefault = function () {
                for (var attr in self.defaultBitrate) {
                    self.defaultBitrate[attr] = self.bitrate[attr];
                }
            };

            // if videoBitrate query param was present and not 'auto', then do not use storage.
            if (fromQuery && bitrateParam != 'auto') {
                logService.log('videoroomCtrl - configured bitrate from query ' + JSON.stringify(self.bitrate));
                updateDefault();
                return;
            }

            var storageParam = storageService.get('sfu-bandwidth');
            if (storageParam) {
                if (setInitialBitrateFromStorage(storageParam)) {
                    //bitrate set;
                    if (fromQuery && bitrateParam == 'auto' && self.bitrate.adjust) {
                        // adjustable bitrate based on storage values.
                        self.bitrate.max = self.bitrate.simulcast;
                        self.bitrate.adjust.video = self.simulcastFlag ? self.bitrate.simulcast : self.bitrate.video;
                        self.bitrate.adjust.screen = self.bitrate.screen;
                    }

                    logService.log('videoroomCtrl - configured bitrate from storage ' + JSON.stringify(self.bitrate));
                    updateDefault();
                    return;
                }
            }
        }

        function setInitialBitrateFromQueryParam(qParam) {
            // Default bitrate can be modified with videoBitrate param:
            // auto, min-max or specific value,
            // e.g., videoBitrate=2500000 for 2.5mb/s;
            // videoBitrate=400000-3500000 for 0.4-3.5 mb/s range;
            // videoBitrate=400000-1000000-2500000 for 0.4-2.5 mb/s range but start at 1 mb/s;
            // videoBitrate=auto for 0.5-3.5 mb/s range.
            // default, if set to 0, is to use 1 mb/s for non-simulcast and 1.5 mb/s for simulcast.

            // if videoBitrateRange is set, then videoBitrate and screenBitrate must not be 0.

            var orig_simulcast = self.bitrate.simulcast;
            var range;
            if (qParam == 'auto') {
                self.bitrate.adjust = {};
                // min and max are default 500000 and 3500000, respectively.
            } else if (qParam.match(/^\d+$/)) {
                self.bitrate.adjust = null;
                self.bitrate.video =
                    self.bitrate.simulcast =
                    self.bitrate.screen =
                    self.bitrate.file =
                        parseInt(qParam);
            } else if (qParam.match(/^\d+-\d+$/)) {
                range = qParam.split('-').map(function (item) {
                    return parseInt(item);
                });
                if (range[0] > range[1]) {
                    logger.warn('setInitialBitrateFromQueryParam', 'invalid videoBitrate range specified');
                    return false;
                }
                self.bitrate.adjust = {};
                self.bitrate.min = range[0];
                self.bitrate.max = range[1];
                // video and screen are treated similarly, simulcast and file are treated similarly.
                self.bitrate.simulcast = self.bitrate.file = Math.min(
                    Math.max(self.bitrate.simulcast, self.bitrate.min),
                    self.bitrate.max
                );
                self.bitrate.video = self.bitrate.screen = Math.min(
                    Math.max(self.bitrate.video, self.bitrate.min),
                    self.bitrate.max
                );
            } else if (qParam.match(/^\d+-\d+-\d+$/)) {
                range = qParam.split('-').map(function (item) {
                    return parseInt(item);
                });
                if (range[0] > range[1] || range[1] > range[2]) {
                    logger.warn('setInitialBitrateFromQueryParam', 'invalid videoBitrate range specified');
                    return false;
                }
                self.bitrate.adjust = {};
                self.bitrate.min = range[0];
                self.bitrate.max = range[2];
                self.bitrate.video = self.bitrate.simulcast = self.bitrate.screen = self.bitrate.file = range[1];
            } else {
                logger.error('setInitialBitrateFromQueryParam', 'invalid videoBitrate param, ignored', qParam);
                return false;
            }

            // derive substream bitrates from simulcast total
            if (self.bitrate.simulcast > orig_simulcast) {
                self.bitrate.substream.high = Math.round(
                    self.bitrate.simulcast - self.bitrate.substream.low - self.bitrate.substream.medium - 100000
                );
            } else if (self.bitrate.simulcast < orig_simulcast) {
                self.bitrate.substream.low = Math.round(
                    Math.max(50000, 100000 * (orig_simulcast / self.bitrate.simulcast))
                );
                self.bitrate.substream.medium = Math.round(
                    Math.max(150000, 400000 * (orig_simulcast / self.bitrate.simulcast))
                );
                self.bitrate.substream.high = Math.round(
                    self.bitrate.simulcast - self.bitrate.substream.low - self.bitrate.substream.medium - 100000
                );
                if (self.bitrate.substream.high < self.bitrate.substream.medium + 100000) {
                    self.bitrate.substream.high = self.bitrate.substream.medium + 100000;
                }
            }

            // initialize auto-adjust bitrates.
            if (self.bitrate.adjust) {
                self.bitrate.adjust.video = self.simulcastFlag ? self.bitrate.simulcast : self.bitrate.video;
                self.bitrate.adjust.screen = self.bitrate.screen;
            }

            return true;
        }

        function setInitialBitrateFromStorage(storageParam) {
            if (!storageParam) {
                return;
            }
            var parsed = JSON.parse(storageParam);
            if (!parsed) {
                return false;
            }

            if (!parsed.standard || !parsed.simulcast) {
                return false;
            }

            //TODO: add some checks for valid int ranges
            logService.log('videoroomCtrl bitrate config from storage: ' + JSON.stringify(parsed));
            self.bitrate.video = self.bitrate.screen = parsed.standard;
            self.bitrate.simulcast = self.bitrate.file = parsed.simulcastTotal;
            self.bitrate.substream = parsed.simulcast;

            return true;
        }

        function onStorageBitrateSettingChanged(e, data) {
            var storageParam = storageService.get('sfu-bandwidth');
            if (storageParam) {
                if (setInitialBitrateFromStorage(storageParam)) {
                    //bitrate set;
                    return;
                }
            }

            //TODO: redo our on the fly calls
        }

        //Get wither low-performance or high-performance (default) bitrate values
        function getTargetPerformanceBitrate() {
            var bitrateObj =
                self.videoLowBitrate === 'lower'
                    ? self.lowerPerformanceBitrate
                    : self.videoLowBitrate
                    ? self.lowPerformanceBitrate
                    : self.defaultBitrate;
            return self.simulcastFlag ? bitrateObj.simulcast : bitrateObj.video;
        }

        // get the video bitrate - consider auto-adjust value or configured value.
        function getVideoBitrate(is_screen) {
            if (self.bitrate.adjust) {
                // auto-adjust bitrate should be used.
                return is_screen ? self.bitrate.adjust.screen : self.bitrate.adjust.video;
            } else {
                return is_screen
                    ? self.fileplay
                        ? self.bitrate.file
                        : self.bitrate.screen
                    : self.simulcastFlag
                    ? self.bitrate.simulcast
                    : self.bitrate.video;
            }
        }

        // TODO: should this part of code be moved to a separate file?

        // called when slow link is detected due to too many NACKs
        // type is one of "video", "audio" or "screen", and lost is integer count.
        // user is optional, and is valid only for type="video" and uplink=false
        // noPrompt is optional, should pass to avoid prompting user to stop publishing
        function onSlowLink(type, uplink, lost, user, noPrompt) {
            var ignoreAudio = false;
            if (type == 'audio' && uplink && attendeeService.getIsAudioMuted()) {
                // audio is muted, ignore uplink audio losses. but adjust video bitrate on audio losses.
                ignoreAudio = true;
            }

            // locate remote div, and display name. div and displayname valie only for video AND !uplink, when user is valid.
            var div = user ? self.getVideoElement(user, true) : null;
            var displayname = user && div ? user + ' ' + (div.getAttribute('displayname') || '') : null;

            logger.warn(
                'onSlowLink',
                'slow link detected',
                `type=${type}`,
                `uplink=${uplink}`,
                `lost=${lost}`,
                displayname ? `user=$${displayname}` : ''
            );

            if (!ignoreAudio) {
                var extra = { sfuEvent: true, lost: lost || undefined };
                if (displayname) {
                    extra.displayname = displayname;
                }
                analyticsWrapperService.eventTrack(
                    'Meeting - slowlink - ' + type + ' - ' + (uplink ? 'uplink' : 'downlink'),
                    extra
                );
            }

            if (type == 'audio') {
                if (uplink) {
                    // TODO: if too many times then disable video publish.
                    if (self.videoroom) {
                        // if video is published, reduce it
                        self.adjustPublisherSlowLinkBandwidth(
                            lost,
                            false,
                            'adjustPublisher onSlowLink audio',
                            noPrompt
                        );
                    } else if (self.screenshare) {
                        // if screen is shared, reduce it
                        self.adjustPublisherSlowLinkBandwidth(lost, true, 'adjustPublisher onSlowLink audio', noPrompt);
                    } // else TODO: if dynamic audio bitrate, reduce it
                } else {
                    // TODO: if too many times then reduce video simulcast substream.
                }
            } else if (uplink) {
                // video or screen publisher
                var is_screen = type == 'screen';
                self.adjustPublisherSlowLinkBandwidth(lost, is_screen, 'adjustPublisher onSlowLink', noPrompt);
            } else {
                // video or screen subscriber
                if (type != 'screen' && !(user && self.isScreenshareId(user))) {
                    // simulcast is not used for screen share.
                    var bitrate = (div && div.availableBitrate && div.availableBitrate.current) || undefined;
                    self.adjustSubscriberSimulcast(div, lost, bitrate, 'adjustSubscriber onSlowLink');
                    self.adjustSubscriberSlowLinkBandwidth(user, lost, bitrate);
                }
            }

            //ANYAM-69470: Ignore screenshare slowlink until we are able to reflect this properly in attendee list
            if (type != 'screen') {
                connectivityService.trackSlowLink(type, uplink ? 'sent' : 'received', lost);
            }

            // update self quality on slow link for tx
            if (!user && uplink && lost) {
                self.updateQualityOnSlowLink(type, lost);
            }
        }

        // adjust simulcast attributes, if enabled, and schedule to reset after timeout..
        function adjustSubscriberSimulcast(div, lost, bitrate, reason) {
            if (div && (!self.adjustSubscriber || self.adjustSubscriber.indexOf('nosimulcast') < 0)) {
                // Do not check for simulcastFlag here, as it can change, and the adjusted bitrate should be used on change.

                if (!self.reduceSubstreamChange.enabled) {
                    if (div.slowLinkTimer) {
                        self.layoutPageTimeoutCancelWithState(div.slowLinkTimer);
                        delete div.slowLinkTimer;
                    }
                }

                if (lost) {
                    if (self.reduceSubstreamChange.enabled) {
                        // cancel global slow link timer
                        if (self.slowLinkGlobalTimer) {
                            $timeout.cancel(self.slowLinkGlobalTimer);
                            self.slowLinkGlobalTimer = null;
                        }
                    }

                    self.adjustSubscriberSimulcastOnLost(div);

                    self.simulcastReason = reason;
                    self.setSimulcast(div);

                    if (!(self.adjustOnAvailableBandwidth && bitrate)) {
                        if (self.reduceSubstreamChange.enabled) {
                            self.adjustSubscriberSimulcastGlobalRevertAfter();
                        } else {
                            self.adjustSubscriberSimulcastRevertAfter(div);
                        }
                    }
                } else if (self.adjustOnAvailableBandwidth && bitrate) {
                    if (!self.shouldAdjustSubscriberSimulcastOnBitrate(div, bitrate)) {
                        return; // no need to update simulcast again, as there is no change.
                    }

                    if (self.reduceSubstreamChange.enabled) {
                        logger.log(
                            'adjustSubscriberSimulcast',
                            'no more slow links => recover simulcast for slow link videos'
                        );

                        self.recoverSimulcastForSlowLinkVideos(reason);
                    } else {
                        self.simulcastReason = reason;
                        self.setSimulcast(div);
                    }
                }
            }
        }

        function adjustSubscriberSimulcastOnLost(div) {
            // increase global slowlink count
            if (!div.slowLinkCount) {
                self.slowLinkGlobalCount += 1;
            }

            // increase slowlink count, but within maxCount
            div.slowLinkCount = Math.min(self.substream.slowlink.maxCount, (div.slowLinkCount || 0) + 1);

            if (self.reduceSubstreamChange.enabled) {
                div.slowLinkPeak = Math.max(div.slowLinkPeak || 0, div.slowLinkCount);

                var userId = div.getAttribute('user');
                self.slowLinkUsers.add(userId);
            }
        }

        function shouldAdjustSubscriberSimulcastOnBitrate(div, bitrate) {
            let changed = false;

            const substream = parseInt(div.getAttribute('substream'));
            const temporal = parseInt(div.getAttribute('temporal'));

            if (!isNaN(substream) && !isNaN(temporal) && div.slowLinkCount) {
                // reduce slowlink count if have enough bitrate now.

                const factor = (self.reduceSubstreamChange.enabled && self.reduceSubstreamChange.factorThreshold) || 1;

                if (factor < 0.5 || factor > 2) {
                    logger.warn(
                        'shouldAdjustSubscriberSimulcastOnBitrate',
                        `reduceSubstreamChange.factorThreshold=${factor}`
                    );
                }

                if (
                    (substream == 0 && bitrate > self.bitrate.subscriber.substream0 * factor) ||
                    (substream == 1 && bitrate > self.bitrate.subscriber.substream1 * factor)
                ) {
                    var delta =
                        self.reduceSubstreamChange.enabled && self.reduceSubstreamChange.resetSlowLink
                            ? div.slowLinkCount
                            : 1;

                    if (delta > 0) {
                        div.slowLinkCount -= delta;

                        if (div.slowLinkCount <= 0) {
                            delete div.slowLinkCount;
                            self.slowLinkGlobalCount -= 1;
                        }
                    }

                    if (!self.reduceSubstreamChange.enabled) {
                        changed = true;
                    } else {
                        // no more slow links => return true as signal to recover simulcast for slow link videos
                        if (!self.slowLinkGlobalCount) {
                            changed = true;
                        }
                    }
                }
            }

            return changed;
        }

        function adjustSubscriberSimulcastGlobalRevertAfter() {
            // create global slow link timer
            self.slowLinkGlobalTimer = $timeout(function () {
                logger.log(
                    'adjustSubscriberSimulcastGlobalRevertAfter',
                    'no more slow links => recover simulcast for slow link videos'
                );

                self.slowLinkGlobalTimer = null;
                self.slowLinkGlobalCount = 0;

                self.recoverSimulcastForSlowLinkVideos('adjustSubscriber onGlobalSlowLink revert on timeout');
            }, self.adjustQualityTimeoutSubscriber);
        }

        function recoverSimulcastForSlowLinkVideos(reason) {
            if (self.slowLinkUsers.size === 0) {
                return;
            }

            self.simulcastReason = reason;

            self.slowLinkUsers.forEach(userId => {
                const userDiv = $window.$('#videoroom-videos > div.remote[user="' + userId + '"]:not(.audioonly)')[0];

                if (userDiv) {
                    if (userDiv.slowLinkCount) {
                        delete userDiv.slowLinkCount;
                    }

                    if (userDiv.slowLinkPeak) {
                        delete userDiv.slowLinkPeak;
                    }

                    self.setSimulcast(userDiv);
                }
            });

            self.slowLinkUsers.clear();
        }

        function adjustSubscriberSimulcastRevertAfter(div) {
            // reset slow link attr after some time, so that it reverts to the right substream.
            div.slowLinkTimer = self.layoutPageTimeoutWithState(
                { div: div },
                function (state) {
                    var div = state.div;
                    delete div.slowLinkTimer;
                    // reduce slowlink count or remove if needed.
                    if (div.slowLinkCount) {
                        delete div.slowLinkCount;
                    }

                    self.simulcastReason = 'adjustSubscriber onSlowLink revert on timeout';
                    self.setSimulcast(div);
                },
                self.adjustQualityTimeoutSubscriber
            );
        }

        function checkAndResetGlobalSlowLinkCount(div) {
            if (div.slowLinkTimer) {
                self.layoutPageTimeoutCancelWithState(div.slowLinkTimer);
                delete div.slowLinkTimer;
            }

            const fid = div.getAttribute('user');

            if (fid && self.reduceSubstreamChange.enabled && self.slowLinkUsers.has(fid)) {
                self.slowLinkGlobalCount -= 1;
                self.slowLinkUsers.delete(fid);
            }
        }

        // send slowlink attendee-message to publisher user, if enabled.
        function adjustSubscriberSlowLinkBandwidth(user, lost, bitrate) {
            if (!self.adjustSubscriber || self.adjustSubscriber.indexOf('noinform') < 0) {
                // if simulcast is not enabled, send a slow link message directly to video publisher.
                var doInform = self.adjustSubscriber && self.adjustSubscriber.indexOf('alwaysinform') >= 0;
                if (doInform || !self.simulcastFlag) {
                    var data = { type: 'slowlink', lost: lost, to: user };
                    if (self.adjustOnAvailableBandwidth) {
                        data.bitrate = bitrate;
                    }
                    socketService.send({
                        message: 'attendee-message',
                        data: data
                    });
                }
            }
        }

        // adjust video or screen publisher bitrate. if lost present, then indicates slowlink, otherwise just adjust bitrate.
        function adjustPublisherSlowLinkBandwidth(lost, is_screen, reason, noPrompt) {
            if (
                self.bitrate.adjust &&
                !self.bitrate.altmax &&
                ((is_screen && self.bitrate.adjust.screen > self.bitrate.min) ||
                    (!is_screen && self.bitrate.adjust.video > self.bitrate.min))
            ) {
                if (
                    self.reducePublisherAdjust.enabled &&
                    !lost &&
                    !is_screen &&
                    !self.reducePublisherAdjustData.videoTimer
                ) {
                    if (self.shouldSkipAdjustPublishBandwidth()) {
                        self.reducePublisherAdjustData.skipCount++;
                        return;
                    } else {
                        self.reducePublisherAdjustData.skipCount = 0;
                    }
                }

                if (is_screen) {
                    self.tryAdjustScreenPublishBandwidth(reason);
                } else {
                    self.tryAdjustVideoPublishBandwidth(lost, reason);

                    if (
                        self.simulcastToggleConfig.onBitrateLow &&
                        self.simulcastToggleState.restricted &&
                        self.bitrate.adjust.video >= self.bitrate.min * self.bitrate.change.incfactor
                    ) {
                        // try enable simulcast when video publish bitrate is not too low
                        self.toggleSimulcastIfNeeded({ bitrateLow: false });
                    }
                }
            } else if (
                self.simulcastToggleConfig.onBitrateLow &&
                self.bitrate.adjust &&
                !is_screen &&
                self.bitrate.adjust.video <= self.bitrate.min &&
                self.bitrate.adjust.video > self.bitrate.lowest
            ) {
                // try to reduce below min bitrate and disable simulcast for publish
                self.tryAdjustVideoPublishBandwidth(lost, reason);
                self.toggleSimulcastIfNeeded({ bitrateLow: true });
            } else if (
                self.bitrate.adjust &&
                !is_screen &&
                lost &&
                self.videoLoss &&
                (self.simulcastToggleConfig.onBitrateLow
                    ? self.bitrate.adjust.video <= self.bitrate.min
                    : self.bitrate.adjust.video == self.bitrate.min)
            ) {
                self.onVideoLossPublish(noPrompt); // bitrate is lowest already, cannot reduce further. then pause it.
            } else {
                // TODO: should reduce bitrate regardless of range param
            }
        }

        // whether to skip increasing the bandwidth, due to small increase in available bitrate.
        function shouldSkipAdjustPublishBandwidth() {
            const newBitrate = self.calculateAdjustVideoPublishBandwidth(0, self.getAdjustVideoPublishBandwidth());

            // if available bitrate is too high, and difference between current and available is not much,
            // skip every x out of y calls to this function (now skip 2 out of 3)

            const skip =
                newBitrate > self.bitrate.adjust.video &&
                newBitrate >= self.reducePublisherAdjust.bitrate.high &&
                newBitrate - self.bitrate.adjust.video <= self.reducePublisherAdjust.bitrate.delta &&
                self.reducePublisherAdjustData.skipCount < self.reducePublisherAdjust.bitrate.skip;

            if (skip) {
                logger.warn(
                    'shouldSkipAdjustPublishBandwidth',
                    `skip change publish video bitrate because of small increase: ${self.bitrate.adjust.video} => ${newBitrate}`,
                    `attempt=${self.reducePublisherAdjustData.skipCount}`
                );
            }

            return skip;
        }

        function tryAdjustScreenPublishBandwidth(reason) {
            if (self.reducePublisherAdjust.enabled) {
                if (self.reducePublisherAdjustData.screenTimer) {
                    // calculate and save new screen publisher bitrate based on previous value (self.reducePublisherAdjustData.screenBandwidth)
                    // for first time use current screen bitrate (self.bitrate.adjust.screen)
                    // don't set it immediately, will set it when timer elapsed
                    self.reducePublisherAdjustData.screenBandwidth = self.calculateAdjustScreenPublishBandwidth(
                        false,
                        self.reducePublisherAdjustData.screenBandwidth // decrease screen bitrate
                    );

                    return;
                } else {
                    self.reducePublisherAdjustData.screenTimer = $timeout(function () {
                        self.reducePublisherAdjustData.screenTimer = null;

                        if (self.reducePublisherAdjustData.screenBandwidth > 0) {
                            if (
                                self.adjustScreenPublishBandwidth(
                                    reason,
                                    self.reducePublisherAdjustData.screenBandwidth
                                )
                            ) {
                                self.createVideoBitrateControl(undefined, true);
                            }

                            self.reducePublisherAdjustData.screenBandwidth = 0;
                        }
                    }, self.reducePublisherAdjust.bitrate.delay);
                }
            }

            const value = self.calculateAdjustScreenPublishBandwidth(false); // decrease screen bitrate

            self.adjustScreenPublishBandwidth(reason, value);

            // to revert after timeout. available bitrate may not change, so do not use lost here.
            self.createVideoBitrateControl(undefined, true);
        }

        // return increased or decreased bitrate based on config and optional current bitrate.
        function calculateAdjustScreenPublishBandwidth(shouldIncrease, currentBitrate) {
            // available bitrate value is often not correct. do not use that.
            return Math.round(
                shouldIncrease
                    ? Math.min(
                          (currentBitrate || self.bitrate.adjust.screen) * self.bitrate.change.incfactor +
                              self.bitrate.change.increase,
                          self.bitrate.max
                      )
                    : Math.max(
                          (currentBitrate || self.bitrate.adjust.screen) * self.bitrate.change.decfactor -
                              self.bitrate.change.decrease,
                          self.bitrate.min
                      )
            );
        }

        function tryAdjustVideoPublishBandwidth(lost, reason) {
            if (self.reducePublisherAdjust.enabled) {
                if (self.reducePublisherAdjustData.videoTimer) {
                    // calculate and save new video publisher bitrate based on previous value (self.reducePublisherAdjustData.videoBandwidth)
                    // for first time use current video bitrate (self.bitrate.adjust.video)
                    // don't set it immediately, will set it when timer elapsed
                    self.reducePublisherAdjustData.videoBandwidth = self.calculateAdjustVideoPublishBandwidth(
                        lost,
                        self.getAdjustVideoPublishBandwidth(),
                        self.reducePublisherAdjustData.videoBandwidth
                    );

                    return;
                } else {
                    self.reducePublisherAdjustData.videoTimer = $timeout(function () {
                        self.reducePublisherAdjustData.videoTimer = null;

                        if (self.reducePublisherAdjustData.videoBandwidth > 0) {
                            if (
                                self.adjustVideoPublishBandwidth(reason, self.reducePublisherAdjustData.videoBandwidth)
                            ) {
                                self.adjustPublisherFrameRateForBitrate(); // adjust framerate too
                                self.createVideoBitrateControl(undefined, false);
                            }

                            self.reducePublisherAdjustData.videoBandwidth = 0;
                        }
                    }, self.reducePublisherAdjust.bitrate.delay);
                }
            }

            const value = self.calculateAdjustVideoPublishBandwidth(lost, self.getAdjustVideoPublishBandwidth());

            if (self.adjustVideoPublishBandwidth(reason, value)) {
                self.adjustPublisherFrameRateForBitrate(); // adjust framerate too
            }

            // to revert after timeout. available bitrate may not change, so do not use lost here.
            self.createVideoBitrateControl(undefined, false);
        }

        // returns available bitrate or current video bitrate for auto adjust.
        function getAdjustVideoPublishBandwidth() {
            const div = self.getVideoElement(undefined, true);
            return div && div.availableBitrate ? div.availableBitrate.current * 1000 : self.bitrate.adjust.video;
        }

        // return increased or decreased (based on lost) video bitrate, based on config,
        // available bitrate and optional current bitrate.
        function calculateAdjustVideoPublishBandwidth(lost, availableBitrate, currentBitrate) {
            if (!currentBitrate) {
                currentBitrate = self.bitrate.adjust.video;
            }

            if (lost) {
                // try to reduce: min(available-bitrate - 100kb/s, current-bitrate - 100kbps) with a min-cap of min-bitrate)
                return Math.round(
                    Math.max(
                        Math.min(availableBitrate, currentBitrate) * self.bitrate.change.decfactor -
                            self.bitrate.change.decrease,
                        self.simulcastToggleConfig.onBitrateLow ? self.bitrate.lowest : self.bitrate.min
                    )
                );
            } else {
                // try to adjust/increase: min(available-bitrate + 100kb/s, current-bitrate + 100kb/s, max-bitrate) with a max-cap of max-bitrate
                let increase = self.bitrate.change.increase;

                // increase by larger amount if available bitrate is too high
                if (self.reducePublisherAdjust.enabled && availableBitrate > currentBitrate) {
                    increase +=
                        Math.max(0, availableBitrate - currentBitrate - self.bitrate.change.increase) *
                        self.reducePublisherAdjust.bitrate.incfactor;
                }

                return Math.round(
                    Math.max(
                        Math.min(
                            Math.min(availableBitrate, currentBitrate) * self.bitrate.change.incfactor + increase,
                            self.bitrate.max
                        ),
                        self.bitrate.min
                    )
                );
            }
        }

        function adjustScreenPublishBandwidth(reason, newValue) {
            if (
                (!self.layoutPage || self.screenshare._configured) &&
                self.bitrate.adjust.screen != newValue &&
                self.screenshareState == 'active'
            ) {
                logger.log(
                    'adjustScreenPublishBandwidth',
                    reason,
                    `will change publish screen bitrate: ${self.bitrate.adjust.screen} => ${newValue}`
                );

                self.bitrate.adjust.screen = newValue;
                self.screenshare.send({
                    message: { request: 'configure', bitrate: self.bitrate.adjust.screen }
                });

                return true;
            }

            return false;
        }

        function adjustVideoPublishBandwidth(reason, newValue) {
            if (self.bitrateLowConfig.type === 'videoLow' && self.useSimulcast2 && self.simulcastFlag) {
                // check if videoLow is changed due to change in desired bitrate
                if (self.adjustVideoLowOnBitrateIfNeeded(self.bitrate.adjust.video, newValue)) {
                    return false;
                }
            }

            if ((!self.layoutPage || self.videoroom._configured) && self.bitrate.adjust.video != newValue) {
                logger.log(
                    'adjustVideoPublishBandwidth',
                    reason,
                    `will change publish video bitrate: ${self.bitrate.adjust.video} => ${newValue}`
                );

                self.bitrate.adjust.video = newValue;
                self.videoroom.send({ message: { request: 'configure', bitrate: self.bitrate.adjust.video } });

                if (self.bitrateLowConfig.type === 'encodings' && self.useSimulcast2 && self.simulcastFlag) {
                    self.reapplySimulcastEncodings();
                }

                self.resetVideoLowQualityLimitationCount();

                return true;
            }

            return false;
        }

        function cancelAdjustVideoPublishBandwidth() {
            self.reducePublisherAdjustData.skipCount = 0;

            if (self.reducePublisherAdjustData.videoTimer) {
                $timeout.cancel(self.reducePublisherAdjustData.videoTimer);
                self.reducePublisherAdjustData.videoTimer = null;
            }

            self.reducePublisherAdjustData.videoBandwidth = 0;
            self.reducePublisherAdjustData.skipCount = 0;
        }

        function cancelAdjustScreenPublishBandwidth() {
            if (self.reducePublisherAdjustData.screenTimer) {
                $timeout.cancel(self.reducePublisherAdjustData.screenTimer);
                self.reducePublisherAdjustData.screenTimer = null;
            }

            self.reducePublisherAdjustData.screenBandwidth = 0;
        }

        // adjust framerate based on the desired bitrate
        function adjustPublisherFrameRateForBitrate() {
            try {
                if (self.videoFramerate == 'auto' && self.videoroom && self.mystream && self.bitrate.adjust) {
                    var videoTrack = self.mystream.getVideoTracks()[0];
                    if (videoTrack) {
                        var bitrate = self.bitrate.adjust.video;
                        var frameRate = self.getMaxFrameRate();
                        if (!self.bitrate.adjust.frameRate) {
                            self.bitrate.adjust.frameRate = frameRate;
                        }
                        // TODO: more experiment needed for the right values/ranges.
                        // currently a change causes a flicker, so need to reduce the number of changes during bitrate fluctuations.
                        if (bitrate <= 300000) {
                            frameRate = Math.min(5, frameRate);
                        } else if (bitrate <= 600000) {
                            frameRate = Math.min(10, frameRate);
                        } else if (bitrate <= 900000) {
                            frameRate = Math.min(15, frameRate);
                        }

                        if (self.bitrate.adjust.frameRate != frameRate) {
                            logService.log(
                                'videoroomCtrl adjustPublisherFrameRateForBitrate(' +
                                    bitrate +
                                    '):' +
                                    self.bitrate.adjust.frameRate +
                                    '=>' +
                                    frameRate
                            );
                            self.bitrate.adjust.frameRate = frameRate;
                            videoTrack.applyConstraints({ frameRate: frameRate });
                        }
                    }
                }
            } catch (err) {
                // in case apply contraints or some other part fails, it should not stop rest of the bitrate adjustment code.
                logger.error('adjustPublisherFrameRateForBitrate', 'Error', err);
            }
        }

        // increase the video or screen bitrate to the next step in the range, if applicable, after a timeout.
        function createVideoBitrateControl(id, is_screen) {
            logger.log('createVideoBitrateControl', `id=${id} is_screen=${is_screen}`);

            var index = (id || self.attendantId) + '-' + (is_screen ? 'screen' : 'video');

            if (self.bitrateTimer[index]) {
                $timeout.cancel(self.bitrateTimer[index]);
                delete self.bitrateTimer[index];
            }

            if (!id) {
                if (
                    self.reducePublisherAdjust.enabled &&
                    self.adjustOnAvailableBandwidth &&
                    !is_screen &&
                    self.videoroom
                ) {
                    // ANYAM-92426: skip adjusting video bitrate here if reduceSubstreamChange enabled and adjustOnAvailableBandwidth is true
                    // we will adjust it based on media stats info, see updateAvailableVideoBitrate
                    return;
                }

                // publisher
                if (
                    self.bitrate.adjust &&
                    !self.bitrate.altmax &&
                    ((is_screen && self.bitrate.adjust.screen < self.bitrate.max) ||
                        (!is_screen && self.bitrate.adjust.video < self.bitrate.max))
                ) {
                    self.bitrateTimer[index] = $timeout(function () {
                        delete self.bitrateTimer[index];

                        if ((is_screen && self.screenshare) || (!is_screen && self.videoroom)) {
                            if (is_screen) {
                                const value = self.calculateAdjustScreenPublishBandwidth(true); // increase screen bitrate
                                self.adjustScreenPublishBandwidth('createVideoBitrateControl', value);
                            } else {
                                const value = self.calculateAdjustVideoPublishBandwidth(
                                    0,
                                    self.getAdjustVideoPublishBandwidth()
                                );

                                if (self.adjustVideoPublishBandwidth('createVideoBitrateControl', value)) {
                                    self.adjustPublisherFrameRateForBitrate(); // adjust framerate too
                                }
                            }

                            // adjust again after timeout as long as bitrate is lower than max.
                            // TODO: can this cause stack overflow for long running call?
                            self.createVideoBitrateControl(undefined, is_screen);
                        }
                    }, self.adjustQualityTimeoutPublisher);
                }
            } else {
                // subscriber
                // TODO: if lower quality then desired, then increase.
            }
        }

        // destroy the timer for adjusting the video or screen publish bitrate.
        function destroyVideoBitrateControl(id, is_screen) {
            var index = (id || self.attendantId) + '-' + (is_screen ? 'screen' : 'video');
            if (self.bitrateTimer[index]) {
                $timeout.cancel(self.bitrateTimer[index]);
                delete self.bitrateTimer[index];
            }
        }

        // change the video bitrate - lower it immediately if slowlink is true, otherwise increase it
        // after a timeout. If lowered, schedule this function to be called again, so that it
        // can increase it after a timeout. The application logic is similar to createVideoBitrateControl
        // and onSlowLink for video publish. The offsets used for increase of descrease are different.
        // This function must not be invoked if bitrate.adjust is set.
        // if bitrate is supplied, then the subscriber informed the publisher about available bitrate adjustment.
        // if slowlink message is received, immediate is true, to apply adjustment immediately.
        function createAltVideoBitrateControl(slowlink, bitrate, immediate) {
            logService.log(
                'videoroomCtrl createAltVideoBitrateControl slowlink=' +
                    !!slowlink +
                    ' bitrate=' +
                    bitrate +
                    ' immediate=' +
                    !!immediate
            );
            var index = self.attendantId + '-videoalt';
            if (self.bitrateTimer[index]) {
                $timeout.cancel(self.bitrateTimer[index]);
                delete self.bitrateTimer[index];
            }
            if (!self.bitrate.adjust) {
                var adjust = {};
                adjust.screen = adjust.video = self.bitrate.altmax = self.bitrate.available = self.getVideoBitrate(); // lock to current bitrate
                self.bitrate.adjust = adjust;
            }
            if (bitrate) {
                self.bitrate.available = bitrate;
            }
            if (slowlink) {
                // reduce bitrate
                if (
                    (!self.layoutPage || self.videoroom._configured) &&
                    self.bitrate.adjust.video > self.bitrate.altmin
                ) {
                    self.bitrate.adjust.video = Math.round(
                        Math.max(
                            self.bitrate.adjust.video * self.bitrate.change.decfactor - self.bitrate.change.decrease,
                            self.bitrate.altmin
                        )
                    );
                    logService.log(
                        'videoroomCtrl createAltVideoBitrateControl will decrease publish video bitrate to ' +
                            self.bitrate.adjust.video
                    );
                    self.videoroom.send({ message: { request: 'configure', bitrate: self.bitrate.adjust.video } });

                    if (self.bitrateLowConfig.type === 'encodings' && self.useSimulcast2 && self.simulcastFlag) {
                        self.reapplySimulcastEncodings();
                    }

                    self.resetVideoLowQualityLimitationCount();
                }
                self.createAltVideoBitrateControl();
            } else {
                // increase bitrate after a timeout
                if (self.bitrate.adjust.video < self.bitrate.altmax) {
                    self.bitrateTimer[index] = $timeout(
                        function () {
                            delete self.bitrateTimer[index];

                            if (self.layoutPage && !self.videoroom._configured) {
                                return; // TODO: call createAltVideoBitrateControl check again after next interval. may not be needed as it will start on next slow link.
                            }
                            var oldvalue = self.bitrate.adjust.video || 0;
                            if (bitrate) {
                                // bitrate was received from subscriber, increment full, no need to increment in 100kb/s
                                self.bitrate.adjust.video = Math.min(self.bitrate.available, self.bitrate.altmax);
                            } else {
                                // increment in 100kb/s, assumes after timeout
                                self.bitrate.adjust.video = Math.round(
                                    Math.min(
                                        self.bitrate.adjust.video * self.bitrate.change.incfactor +
                                            self.bitrate.change.increase,
                                        self.bitrate.altmax
                                    )
                                );
                                if (self.bitrate.available) {
                                    // limit to available bitrate, if known.
                                    self.bitrate.adjust.video = Math.min(
                                        self.bitrate.adjust.video,
                                        self.bitrate.available
                                    );
                                }
                            }
                            if (oldvalue != self.bitrate.adjust.video) {
                                logService.log(
                                    'videoroomCtrl createAltVideoBitrateControl will increase publish video bitrate to ' +
                                        self.bitrate.adjust.video
                                );
                                self.videoroom.send({
                                    message: { request: 'configure', bitrate: self.bitrate.adjust.video }
                                });

                                if (
                                    self.bitrateLowConfig.type === 'encodings' &&
                                    self.useSimulcast2 &&
                                    self.simulcastFlag
                                ) {
                                    self.reapplySimulcastEncodings();
                                }

                                self.resetVideoLowQualityLimitationCount();
                            }

                            if (self.bitrate.adjust.video < self.bitrate.altmax) {
                                self.createAltVideoBitrateControl();
                            } else {
                                self.bitrate.altmax = self.bitrate.available = 0;
                                self.bitrate.adjust = null;
                            }
                        },
                        immediate ? 0 : self.adjustQualityTimeoutPublisher
                    );
                }
            }
        }

        // destroy the timer for adjusting the video bitrate if range is not set.
        function destroyAltVideoBitrateControl() {
            var index = self.attendantId + '-videoalt';
            if (self.bitrateTimer[index]) {
                $timeout.cancel(self.bitrateTimer[index]);
                delete self.bitrateTimer[index];
                self.bitrate.altmax = self.bitrate.available = 0;
                self.bitrate.adjust = null;
            }
        }

        // update the bitrate property on the corresponding div, and send slowlink event to publisher if
        // bitrate is quite different.
        function updateAvailableVideoBitrate(id, outbound, bitrate) {
            //TODO: keep the log commented. enable for debugging.
            //logService.log('videoroomCtrl available bitrate id=' + id + ' outbound=' + outbound + ' bitrate=' + bitrate);

            var div = !outbound
                ? $window.$('#videoroom-videos > div.remote[user="' + id + '"]')[0]
                : $window.$('#videoroom-videos > div.local')[0];
            if (div) {
                if (bitrate) {
                    if (div.availableBitrate === undefined) {
                        div.availableBitrate = { previous: bitrate }; // initialize previous same as initial value.
                    }
                    div.availableBitrate.current = bitrate;

                    if (!outbound) {
                        // adjust simulcast attributes if needed.
                        self.adjustSubscriberSimulcast(div, undefined, bitrate, 'adjustSubscriber onBitrate');

                        // if significant change in bitrate, then send slowlink to adjust bitrate if needed.
                        // significant change is increase by more than 10% or decrease by more than 100kbps.
                        // if bitrate remains consistently above 1000kb/s, no need to send.
                        if (
                            (div.availableBitrate.current >
                                div.availableBitrate.previous * self.bitrate.detect.increase ||
                                div.availableBitrate.current <
                                    div.availableBitrate.previous - self.bitrate.detect.decrease) &&
                            (div.availableBitrate.current < self.bitrate.subscriber.currentLimit ||
                                div.availableBitrate.previous < self.bitrate.subscriber.previousLimit)
                        ) {
                            div.availableBitrate.previous = div.availableBitrate.current; // avoid sending another msg, until another significant change.
                            self.adjustSubscriberSlowLinkBandwidth(id, undefined, bitrate);
                        }
                    } else if (self.bitrate.adjust) {
                        // auto-adjust is enabled for video publish
                        if (
                            self.videoroom &&
                            (div.availableBitrate.current >
                                div.availableBitrate.previous * self.bitrate.detect.increase ||
                                div.availableBitrate.current <
                                    div.availableBitrate.previous - self.bitrate.detect.decrease)
                        ) {
                            div.availableBitrate.previous = div.availableBitrate.current; // avoid adjusting again, unless significant change
                            self.adjustPublisherSlowLinkBandwidth(undefined, false, 'adjustPublisher onBitrate');
                        } else if (
                            // adjustOnAvailableBandwidth is true, is_screen is false
                            self.videoroom &&
                            self.reducePublisherAdjust.enabled &&
                            !self.bitrate.altmax &&
                            self.bitrate.adjust.video < self.bitrate.max
                        ) {
                            div.availableBitrate.previous = div.availableBitrate.current;
                            self.adjustPublisherSlowLinkBandwidth(undefined, false, 'adjustPublisher onBitrate notMax');
                        }
                    }
                } else {
                    delete div.availableBitrate;
                }
            }
        }

        function enableLowPerformanceBitrate() {
            logService.log('videoBitrateService - enableLowPerformanceBitrate');

            Object.assign(
                self.bitrate,
                self.videoLowBitrate === 'lower' ? self.lowerPerformanceBitrate : self.lowPerformanceBitrate
            );

            if (self.bitrate.adjust) {
                var lowPerfBitrate = self.getTargetPerformanceBitrate();
                self.bitrate.adjust.video = Math.min(self.bitrate.adjust.video, lowPerfBitrate);
            }

            if (self.bitrate.altmax) {
                var targetAltMax = self.getVideoBitrate(false);
                self.bitrate.altmax = Math.min(self.bitrate.altmax, targetAltMax);
            }

            // TODO: why is configure not sent here?

            if (self.mystream) {
                // if video stream is enabled
                self.createVideoBitrateControl();

                if (self.bitrate.altmax) {
                    self.createAltVideoBitrateControl();
                }
            }
        }

        function disableLowPerformanceBitrate() {
            logService.log('videoBitrateService - disableLowPerformanceBitrate');

            var previousTargetAltMax = self.getVideoBitrate(false);

            Object.assign(self.bitrate, self.defaultBitrate);

            var highPerfBitrate = self.getTargetPerformanceBitrate();
            if (self.bitrate.adjust && self.bitrate.adjust.video >= highPerfBitrate) {
                self.bitrate.adjust.video = highPerfBitrate;
            }

            if (self.bitrate.altmax && self.bitrate.altmax >= previousTargetAltMax) {
                var targetAltMax = self.getVideoBitrate(false);
                self.bitrate.altmax = targetAltMax;
            }

            if (self.mystream) {
                self.createVideoBitrateControl();

                if (self.bitrate.altmax) {
                    self.createAltVideoBitrateControl();
                }
            }
        }

        function reapplyPublishBitrate() {
            var previousValue = self.videoLowBitrate;
            var newValue = self.getIsVideoLow();

            if (previousValue !== newValue) {
                // detect undefined => false change too.
                self.videoLowBitrate = newValue;
                if (newValue) {
                    self.enableLowPerformanceBitrate();
                } else {
                    self.disableLowPerformanceBitrate();
                }
            }
        }
    }
]);
